import useAjax from "@apis/useAjax";
import { useSnackbar } from "notistack";
import {
	GET_CYCLE_PURCHASE_EFFECT_ORDER_API,
	POST_CYCLE_PURCHASE_EFFECT_ORDER_API,
	PUT_CYCLE_PURCHASE_EFFECT_ORDER_API,
	DELETE_CYCLE_PURCHASE_EFFECT_ORDER_API,
	POST_CYCLE_PURCHASE_EFFECT_RANGE_API,
} from "@apis/apiPath";
import { isEmpty } from "@util/utils";

const useCyclePurchaseEffectApi = () => {
	const Ajax = useAjax();
	const { enqueueSnackbar } = useSnackbar();

	// 取得循環變更單內容
	const getCyclePurchaseEffectOrderApi = async (cycleOrderID, effectID) => {
		return await Ajax.get(GET_CYCLE_PURCHASE_EFFECT_ORDER_API(cycleOrderID, effectID));
	};

	// 新增變更單
	const postCyclePurchaseEffectOrderApi = async parameters => {
		const resp = await Ajax.post(POST_CYCLE_PURCHASE_EFFECT_ORDER_API, parameters);
		if (!isEmpty(resp) && resp.isError && typeof resp.result === "string") return null; // 排除 0002 錯誤
		return resp;
	};

	// 更新變更單
	const putCyclePurchaseEffectOrderApi = async (parameters, EffectID) => {
		const resp = await Ajax.put(PUT_CYCLE_PURCHASE_EFFECT_ORDER_API(EffectID), parameters);
		if (!isEmpty(resp) && resp.isError && typeof resp.result === "string") return null; // 排除 0002 錯誤
		return resp;
	};

	// 刪除變更單(須為未生效)
	const deleteCyclePurchaseEffectOrderApi = async (EffectID, employeeID) => {
		const params = { employeeID };
		const resp = await Ajax.delete(DELETE_CYCLE_PURCHASE_EFFECT_ORDER_API(EffectID), params);
		if (resp) enqueueSnackbar("刪除成功", { variant: "success" });
		return resp;
	};

	const postCyclePurchaseEffectRangeApi = async parameters => {
		return await Ajax.post(POST_CYCLE_PURCHASE_EFFECT_RANGE_API, parameters);
	};

	return {
		getCyclePurchaseEffectOrderApi,
		postCyclePurchaseEffectOrderApi,
		putCyclePurchaseEffectOrderApi,
		deleteCyclePurchaseEffectOrderApi,
		postCyclePurchaseEffectRangeApi,
	};
};

export default useCyclePurchaseEffectApi;
